import React, { FC, ReactElement, useState, useEffect, useMemo } from 'react';
import { Modal, Spin } from 'antd';
import { CustomFileViewer } from 'components';
import api, {OP_TYPE_ENU} from 'api/xqjy-service'

interface IProps {
  shortCode: string,
  visible: boolean,
  handleCancel: ()=>void,
  fileName?: string,
  resId?: number
}

const FileViewDialog: FC<IProps> = (props:IProps): ReactElement => {

  const {shortCode, fileName, resId, visible, handleCancel} = props
  const [fileDTO, setFileDTO] = useState<any>({})
  const [loading, setLoading] = useState(false)

  useEffect(()=>{
    if(shortCode){
      setLoading(true)
      api.file.detail(shortCode).then(result=>{
        setFileDTO(result.data)
      }).finally(()=>{
        setLoading(false)
      })
    }
    if(resId) {
      api.res.oplog(resId, OP_TYPE_ENU.VIEW)
    }
  }, [shortCode, resId])

  const title = useMemo(()=>{
    if(fileName){
      return fileName
    }
    if(fileDTO && fileDTO.fileName){
      return fileDTO.fileName
    }
    return ''
  }, [fileName, fileDTO])

  const clearViewer = ()=>{
    setFileDTO({})
  }

  return (
    <Modal destroyOnClose title={title} visible={visible} onCancel={handleCancel} afterClose={clearViewer} footer={null} width={800}  bodyStyle={{maxHeight:'800px',overflowY:'auto'}}>
      <Spin spinning={loading}>
        <CustomFileViewer 
          shortCode={shortCode}
          resId={resId}
          fileType={fileDTO.fileSuffix}
          filePath={fileDTO.url}/>
      </Spin>
    </Modal>
  )
}

export default FileViewDialog